import { serializable, object, list, primitive, alias } from 'serializr';

export class YoYEmission {
  @serializable(primitive())
  year?: number;

  // Rounding totalCO2e to 2 decimal places during deserialization
  @serializable(alias('total_co2e', primitive()))
  get totalCO2e(): number | undefined {
    return this._totalCO2e !== undefined
      ? Number(this._totalCO2e.toFixed(2))
      : undefined;
  }

  set totalCO2e(value: number | undefined) {
    this._totalCO2e = value;
  }

  private _totalCO2e?: number;

  @serializable(alias('target_co2e', primitive()))
  targetCO2e?: number;
}

export class YoYEmissionsResponse {
  @serializable(alias('yoy_emission', list(object(YoYEmission))))
  yoyEmission?: YoYEmission[];
}
export class YoYEmissionsProductResponse {
  @serializable(alias('yoy_product_emission', list(object(YoYEmission))))
  yoyEmission?: YoYEmission[];
}
